/** 项目「任务」Tab：本项目执行记录（AI 审核 / AI 脱敏 / HTML 生成 / 发布批次），点击查看批次详情。 */
import { useState } from 'react';
import { type ProjectDetail, useLandingProjectExecutions } from '~/data/queries';
import { Icons } from '~/lib/icons';
import { Pagination } from '~/ui/Pagination';
import { Spinner } from '~/ui/Skeleton';
import { LandingAiUsage } from './LandingAiUsage';
import { ProjectProgressSummary } from './landing-project-display';
import '../LandingTasksPanel.css';
export function LandingProjectExecutionsPanel({
  project,
  onExecution,
}: { project: ProjectDetail; onExecution: (id: string) => void }) {
  const [page, setPage] = useState(1);
  const history = useLandingProjectExecutions(project.id, page);
  return (
    <div className="vstack" style={{ gap: 12 }}>
      {history.isError ? (
        <div className="card landing-project-state" role="alert">
          <Icons.IconAlert size={18} style={{ color: 'var(--neg)' }} />
          <span className="landing-project-state-message">{history.error.message}</span>
          <button type="button" className="btn" onClick={() => void history.refetch()}>
            重新加载
          </button>
        </div>
      ) : history.isPending ? (
        <div className="landing-project-state" role="status">
          <Spinner size={16} />
          <span>加载执行记录…</span>
        </div>
      ) : !history.data?.data.length ? (
        <div className="card landing-project-state">
          <Icons.IconLayers size={18} style={{ color: 'var(--fg-faint)' }} />
          <span className="muted">
            暂无执行记录。提交 AI 审核、AI 脱敏、HTML 生成或发布后，可在这里查看进度与结果。
          </span>
        </div>
      ) : (
        history.data.data.map((execution) => (
          <button
            key={execution.id}
            type="button"
            className="card focusable landing-project-execution-card"
            onClick={() => onExecution(execution.id)}
          >
            <ProjectProgressSummary execution={execution} />
            {(execution.operation === 'review' || execution.operation === 'desensitize') && (
              <LandingAiUsage usage={execution.ai_usage} compact />
            )}
          </button>
        ))
      )}
      <Pagination total={history.data?.total ?? 0} page={page} pageSize={20} onChange={setPage} />
    </div>
  );
}
